<template>
  <ProgressCard
    :title="$t('fa-bu-lie-biao')"
    :extra="$t('xian-shi-zui-jin-10-tiao-shu-ju')"
    :list="progressList"
    :type="PROGRESS_TYPE.PUBLISH"
    @close="onClose"
  >
    <template #content="{ dataSource }">
      <div class="flex items-center text-[12px] text-font-50 leading-none">
        <Resource
          class="w-[14px] h-[14px] mr-[4px]"
          :src="PLATFORM_TYPE()[(dataSource as IGetProcessRes).platform_type]?.icon"
          :transform-resource="transformImage"
        />
        <span
          v-if="dataSource.status === PUBLISH_STATUS.FAIL"
          class="overflow-hidden text-red-400 text-ellipsis"
        >
          {{ UPLOAD_STATUS_MAP()[(dataSource as IGetProcessRes).status] }}
          - {{ dataSource.error_reason }}
        </span>
        <span v-else>
          {{ UPLOAD_STATUS_MAP()[(dataSource as IGetProcessRes).status] }}
          <span v-if="dataSource.status === PUBLISH_STATUS.DOING">
            {{ Math.floor(dataSource.processing * 100) }}%
          </span>
        </span>
      </div>
    </template>
    <template #action="{ dataSource }">
      <iconpark-icon
        v-if="[PUBLISH_STATUS.FINISH].includes(dataSource.status)"
        name="check-thin"
        class="text-[16px] text-success"
      ></iconpark-icon>
      <!-- <a-tooltip
        v-if="[PUBLISH_STATUS.WAIT].includes(dataSource.status)"
        placement="topRight"
      >
        <template #title>取消当前视频上传</template>
        <iconpark-icon
          name="close"
          class="text-[16px] text-font-40"
          @click="() => cancel(dataSource)"
        ></iconpark-icon>
      </a-tooltip> -->
    </template>
  </ProgressCard>
</template>

<script lang="ts" setup>
// import { MinusOutlined } from '@ant-design/icons-vue'
import { cancelPublish, getPublishList } from '@/api';
import { UPLOAD_STATUS_MAP, PLATFORM_TYPE } from '@/constants/publish';
import { PUBLISH_STATUS, type IGetProcessRes } from '~/api/interface/publish';
const showProcess = usePublishProcess();

const timer = ref();
const progressList = ref<IGetProcessRes[]>([]);
const { $t } = useNuxtApp();

const publishNum = computed(
  () =>
    progressList.value.filter(item =>
      [PUBLISH_STATUS.WAIT, PUBLISH_STATUS.DOING].includes(item.status),
    ).length,
);

watch(
  () => publishNum.value,
  (cur, before) => {
    if (cur !== before) {
      setProgress(PROGRESS_TYPE.PUBLISH, {
        count: cur,
      });
    }
  },
);

const cancel = async (item: IGetProcessRes) => {
  const res = await cancelPublish({
    id: item.id,
  });

  if (!res.code) {
    message.success($t('cao-zuo-cheng-gong'));
    fetchProgressList();
  }
};

watch(
  () => showProcess.value?.id,
  (cur, before) => {
    if (cur !== before && cur) {
      clearProgress();
      fetchProgressList();
    }
  },
);

// 清除轮询
const clearProgress = () => {
  if (timer.value) {
    clearTimeout(timer.value);
  }
};

const onClose = () => {
  clearProgress();
  showProcess.value = undefined;
};

// 获取分享中数据
const fetchProgressList = async () => {
  const res = await getPublishList({
    many: true,
    page: 1,
    page_size: 10,
  });

  if (!res.code && res?.data) {
    progressList.value = res.data?.results.map(item => ({
      ...item,
      percent: item.processing * 100,
    }));

    const waitStatus = [PUBLISH_STATUS.WAIT, PUBLISH_STATUS.DOING];
    const isDoing = res.data.results.find((item: IGetProcessRes) =>
      waitStatus.includes(item.status),
    );

    if (isDoing) {
      timer.value = setTimeout(() => {
        fetchProgressList();
      }, 1000 * 5);
    } else {
      clearProgress();
    }
  }
};

// const toggleVisible = () => {
//   setProgress(PROGRESS_TYPE.PUBLISH, {
//     show: false,
//   })
//   // visible.value = !visible.value
// }

onMounted(() => {
  fetchProgressList();
});

onUnmounted(() => {
  clearProgress();
});
</script>

<style lang="scss">
.youyan-share-progress-twice {
  position: fixed;
  bottom: 16px;
  z-index: 21;
  .ant-badge-count {
    top: 6px;
  }

  .content {
    @apply w-[500px] z-30 bg-back-1 rounded-[8px];
    border: 1px solid var(--back-3);
    box-shadow: 0px 2px 19px 0px rgba(0, 0, 0, 0.1);
  }
  .circle-download {
    @apply w-[48px] h-[48px] bg-back-1 rounded-full cursor-pointer flex-y-center justify-center;
    box-shadow: 0px 2px 19px 0px rgba(0, 0, 0, 0.1);
  }
  .modal-title {
    @apply px-[16px] py-[8px];
    border-bottom: 1px solid var(--back-3);
  }

  .progress-line {
    .ant-progress-bg {
      height: 2px !important;
    }
  }
  .progress-item {
    &:first-child {
      margin-top: 0;
    }
    .text-color {
      color: rgba(255, 255, 255, 0.3);
    }
  }
}
</style>
